<template>
    <div>
        <HeaderBg :img="img" title="الوصفات الطبية" :links="links" />
        <!-- <header class="admin_content_header">
            <div class="filter">
                <select>
                    <option value="" selected disabled>المدينة</option>
                </select>
                <div class="tabs_filter">
                    <div class="active_tap">الكل</div>
                    <div>الأكثر شراء</div>
                    <div>النقاط</div>
                </div>
            </div>
            <div class="search">
                <input type="text" placeholder="البحث برقم الفرع">
            </div>
            
        </header> -->
        <RequestSpinner v-if="loadingRequest == true" />
        <div class="request_table_container">
            <div class="detailsTable" v-if="loadingRequest == false">
                <div class="table_header">
                    <div class="block">
                        رقم الطلب
                    </div>
                    <div class="block">
                        رقم الوصفة
                    </div>
                    <div class="block">
                        معلومات الاتصال
                    </div>
                    <div class="block">
                        الحالة
                    </div>
                </div>
                <div class="table_row" v-for="prescription in prescriptions" :key="prescription.id">
                    <div class="block">
                        <span class="colorNumber">#{{prescription.id}}</span>
                    </div>
                    <div class="block">
                        <h3>{{prescription.prescription_no !== '' ?  prescription.prescription_no : 'لا يوجد'}}</h3>
                    </div>
                    <div class="block">
                        <h5>{{prescription.user}}</h5>
                        <h3>{{prescription.mobile}}</h3>
                    </div>
                    <div class="block">
                        <h4 class="Processing" v-if="prescription.status.name == 'قيد التنفيذ'">{{prescription.status.name}}</h4>
                        <h4 class="deliverd" v-if="prescription.status.name == 'مقبول'">{{prescription.status.name}}</h4>
                        <h4 class="cancel" v-if="prescription.status.name == 'مرفوض'">{{prescription.status.name}}</h4>
                        <select @change="(e) => updateStatus(e, prescription.id)">
                            <option value="" selected disabled>{{prescription.status.name}}</option>
                            <option :value="status.id" v-for="status in orderStatus" :key="status.id"> {{status.translation[0].name}} </option>
                        </select>
                        <h3>{{prescription.date.slice(0, 10)}}</h3>
                    </div>
                    
                   
                </div>
            </div>
        </div>
        <div class="pagination mt-5" v-if="prescriptions.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import Request from '../../../services/Request';
import store from "@/store/index.js";
export default {
    name: 'MyPrescriptions',
    components: {HeaderBg, RequestSpinner},
    data(){
        return{
            loadingRequest: true,
            details: false,
            img: require('../../../assets/images/prescriptionLarg.png'),
            links: [
                {
                    to:"/store-admin/prescriptions/mine",
                    link: 'وصفاتي',
                    active: 'active'
                },
                {
                    to:"/store-admin/prescriptions/cash",
                    link: 'نقدا',
                },
                {
                    to:"/store-admin/prescriptions/insurance",
                    link: 'تأمين'
                }
            ],
            prescriptions: [],
            orderStatus: [],

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    mounted(){
        // get pagination page number from url
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');
        if(page){
            this.currentPage = page
        }
        this.getPrescriptions();    
        this.getOrderStatus();    
    },
    methods:{
        openDetails(){
            this.details = !this.details
        },
        getPrescriptions(){
            Request.fetch('admin/prescriptions', this.apiParams , {
                limit: store.state.limit,
                type: 'mine'
            })
            .then((response) => {
                this.loadingRequest = false;
                this.pages = response.data.total / store.state.limit
                this.prescriptions = response.data.data
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/')
                    localStorage.removeItem('token')
                }
            });
        },
        
        getOrderStatus(){
            axios.get(`https://app.almujtama.com.sa/admin/orderStatus`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Authorization': 'Bearer '+ localStorage.getItem('token'),
                }
            })
            .then((response) => {
                this.orderStatus = response.data.data
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/')
                    localStorage.removeItem('token')
                }
            });
        },
        updateStatus(e, id){
            console.log(e.target.value)
            Request.put('admin/updateStatus',id, {
                type : "prescription",
                status : e.target.value
            })
            .then( () => {
                this.getPrescriptions();
            })
        },
        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getPrescriptions();
            } else{
                this.apiParams = `?page=${val}`;
                this.getPrescriptions();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.Processing{
    color: #EEAF33;
}
.deliverd{
    color: #42FF68;
}
.cancel{
    color: #FF3D3D;
}
.colorNumber{
    color: #2E4765;
    text-decoration: underline;
}
.table_header{
    background-color: #FFF;
    display: flex;
    margin-bottom: 20px;
    border-radius: 10px;
    .block{
        width: calc(100% / 4);
        text-align: center;
        padding: 15px 0;
        font-weight: 600;
        font-family: flatMedium;
    }
}
.table_row{
    h3,
    h5,
    span{
        font-family: flatMedium;
    }
}
.table_row{
    flex-wrap: wrap;
}
.block{
    width: calc(100% / 4);
    select{
        border: 0;
        font-size: 16px;
        cursor: pointer;
        option{
            color: #000;
        }
    }
}
.details_container{
    width: 100%;
    padding: 10px 40px;
    .details_table{
        .table_header{
            .block{
                color: #1D4D90;
                font-weight: 900;
                font-family: flatMedium;
                width: calc(100% / 5) !important;        
            }
        }
    }
    .table_row{
        .block{
            width: calc(100% / 5) !important;
        }
    }
}
</style>